export default {
  nav: {
    about: 'О платформе',
    forWhom: 'Для кого',
    opportunities: 'Возможности',
    faq: 'FAQ'
  },
  hero: {
    badge: 'Платформа человеческого интеллекта',
    title: 'Человеческий интеллект для эпохи ИИ',
    subtitle: 'Зарабатывайте удалённо, помогая обучать передовые AI-модели и создавая качественные датасеты для AGI',
    englishRequired: '🇬🇧 Необходимо свободное владение английским языком'
  },
  cta: {
    start: 'Начать',
    getStarted: 'Присоединиться сейчас',
    learnMore: 'Узнать больше',
    startNow: 'Начать сейчас'
  },
  about: {
    badge: 'О micro1',
    title: 'Платформа нового поколения для работы с данными',
    desc1: 'micro1 — это глобальная платформа, объединяющая экспертов со всего мира для создания высококачественных данных, необходимых для обучения передовых AI-моделей и систем искусственного общего интеллекта (AGI).',
    desc2: 'Мы сотрудничаем с ведущими AI-лабораториями и технологическими компаниями, предоставляя доступ к проверенным специалистам, которые выполняют сложные задачи: разметку данных, оценку моделей, создание контента и экспертную валидацию.',
    desc3: 'Каждый участник платформы проходит тщательный отбор через нашего AI-рекрутера Zara, что гарантирует высочайшее качество работы и профессионализм команды.',
    englishNote: '⚠️ Важно: Все собеседования и задания на платформе выполняются на английском языке. Свободное владение английским — обязательное требование для работы.',
    quote: 'Человеческая экспертиза остаётся незаменимой в эпоху ИИ. micro1 превращает человеческие знания и навыки в фундамент, на котором строится будущее искусственного интеллекта.',
    quoteName: 'Команда micro1',
    quoteRole: 'Платформа человеческого интеллекта'
  },
  forWhom: {
    title: 'Для кого эта платформа?',
    subtitle: 'micro1 открыта для специалистов разных областей, готовых работать удалённо и вносить вклад в развитие AI-технологий',
    categories: [
      {
        title: 'Аннотаторы и разметчики данных',
        desc: 'Специалисты по разметке изображений, текстов, аудио и видео для обучения моделей компьютерного зрения, NLP и мультимодальных систем.',
        icon: 'ri-image-edit-line'
      },
      {
        title: 'Оценщики моделей AI',
        desc: 'Эксперты, которые тестируют и оценивают качество ответов языковых моделей, проверяют точность, безопасность и соответствие этическим стандартам.',
        icon: 'ri-star-line'
      },
      {
        title: 'Создатели контента и редакторы',
        desc: 'Копирайтеры, редакторы и лингвисты, создающие качественный текстовый контент для обучения и файнтюнинга языковых моделей на разных языках.',
        icon: 'ri-edit-line'
      },
      {
        title: 'Программисты и разработчики',
        desc: 'Специалисты по написанию кода, проверке решений, созданию синтетических данных для обучения AI-моделей программированию и кодогенерации.',
        icon: 'ri-code-s-slash-line'
      },
      {
        title: 'Эксперты в предметных областях',
        desc: 'Профессионалы в медицине, праве, науке, финансах и других сферах, предоставляющие экспертные знания для специализированных AI-приложений.',
        icon: 'ri-graduation-cap-line'
      },
      {
        title: 'Специалисты по робототехнике',
        desc: 'Операторы, которые собирают реальные данные о физических действиях и движениях для обучения роботизированных систем и гуманоидов нового поколения.',
        icon: 'ri-robot-2-line'
      }
    ]
  },
  opportunities: {
    badge: 'Простой процесс',
    title: 'Три шага до первого заработка',
    steps: [
      {
        number: '01',
        title: 'Регистрация',
        desc: 'Перейдите по реферальной ссылке и заполните анкету. Расскажите о своих навыках и опыте.'
      },
      {
        number: '02',
        title: 'Проверка навыков',
        desc: 'Пройдите тестирование через AI-рекрутера Zara. Это может включать задачи, собеседование или экспертную оценку.'
      },
      {
        number: '03',
        title: 'Выбор задач',
        desc: 'После одобрения получите доступ к платформе и выбирайте задачи, соответствующие вашим навыкам и интересам.'
      },
      {
        number: '04',
        title: 'Работа и оплата',
        desc: 'Выполняйте задачи в удобное время, получайте оплату за качественную работу и развивайте экспертизу в AI-индустрии.'
      }
    ]
  },
  faq: {
    title: 'Часто задаваемые вопросы',
    subtitle: 'Ответы на самые распространённые вопросы о работе на платформе',
    items: [
      {
        q: 'Нужно ли знать английский язык для работы?',
        a: 'Да, свободное владение английским языком является обязательным требованием. Все собеседования с AI-рекрутером Zara, инструкции к заданиям, коммуникация с командой и сама работа выполняются исключительно на английском. Уровень владения будет проверен на этапе отбора.'
      },
      {
        q: 'Сколько я могу заработать на платформе micro1?',
        a: 'Заработок зависит от типа задач, вашей квалификации и времени, которое вы инвестируете. Платформа не гарантирует фиксированный доход, но многие специалисты получают конкурентное вознаграждение за качественную работу. Ставки варьируются в зависимости от сложности проекта и вашей экспертизы.'
      },
      {
        q: 'Нужен ли мне опыт работы с ИИ для начала?',
        a: 'Нет, конкретный опыт работы с ИИ не всегда требуется. Многие задачи подходят для людей без технического образования. Основные требования — внимательность, способность следовать инструкциям и желание учиться. Некоторые специализированные задачи могут требовать экспертизы в конкретных областях.'
      },
      {
        q: 'Как проходит процесс отбора?',
        a: 'После регистрации вы взаимодействуете с AI-рекрутером Zara, который оценивает ваши навыки через тесты, задания или собеседования (на английском языке). Процесс занимает от нескольких дней до нескольких недель в зависимости от сложности позиции. Отбор направлен на поиск лучших специалистов для каждого типа задач.'
      },
      {
        q: 'Могу ли я работать из любой страны?',
        a: 'Да, micro1 — это глобальная платформа, открытая для специалистов из разных стран. Однако некоторые проекты могут иметь региональные ограничения или языковые требования (обязательный английский). Проверьте детали при регистрации.'
      },
      {
        q: 'Какой график работы на платформе?',
        a: 'Работа полностью удалённая и гибкая. Вы сами выбираете, когда и сколько работать, в зависимости от доступных задач и вашего расписания. Это может быть как полная занятость, так и подработка в свободное время.'
      },
      {
        q: 'Как выплачивается вознаграждение?',
        a: 'Оплата производится согласно условиям конкретного проекта. Обычно используются международные платёжные системы. Детали относительно способов оплаты, частоты и минимальных сумм уточняются после одобрения на платформе.'
      }
    ]
  },
  finalCta: {
    title: 'Готовы начать?',
    subtitle: 'Присоединяйтесь к тысячам специалистов по всему миру, которые помогают создавать будущее AI',
    button: 'Зарегистрироваться сейчас',
    social: 'Более 10 000 специалистов уже с нами'
  },
  footer: {
    description: 'Платформа человеческого интеллекта для обучения AI-моделей и создания высококачественных датасетов для AGI.',
    contact: 'Контакты',
    links: 'Навигация',
    company: 'Компания',
    careers: 'Карьера',
    research: 'Исследования'
  }
};
